import useIsInIframe from 'hooks/store/useIsInIframe';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IReduxState } from 'store/reducers';
import { authenticationSetTokenAction, sessionResetAction } from 'store/store';
import { useFeatureFlags } from 'utils/features';
import { navigateToEmberApp } from 'utils/routeUtils';

export default function useLogin() {
  const dashboardEnabled = useFeatureFlags('DASHBOARD');
  const environment = useSelector<IReduxState, string>((state) => state.environment.REACT_APP_LEGACY_URL);
  const isInIframe = useIsInIframe();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (memberId: string, publicKey: string) => {
    const token = btoa(`${publicKey}:${memberId}`);
    dispatch(sessionResetAction());
    dispatch(authenticationSetTokenAction(token));
    if (dashboardEnabled) {
      setTimeout(() => navigate({ pathname: '/' }), 0);
    } else if (!isInIframe) {
      navigateToEmberApp(environment, memberId, publicKey);
    }
  };
}
